import React, { useEffect, useMemo, useState } from 'react';
import WhatsAppButton from './whatsapp';
import Header from './Header';
import Footer from './Footer';
import axios from 'axios';
import Chat from './chat';
import { Helmet } from 'react-helmet';
import Call from './call';
import Marquee from './marquee';

const Kitchen = () => {
  const [category, setcategory] = useState([]);
  const [categorys, setcategorys] = useState([]);
  const [wall, setwall] = useState([]);
  const [feet, setfeet] = useState([]);

  const [accessoriesQty, setaccessoriesQty] = useState({});

  const [formData, setformData] = useState({
    name: '',
    email: '',
    phone: '',
    accessories: {},
    city: '',
    home: '',
    kichen_shape: '',
    cabinet: '',
    finish: '',
    wall: '',
    feet: ''
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/kitchencalculatormapping');
    setcategory(res.data.kitchen_calculator );
    setcategorys(res.data.kitchen_shape );
  };

  const handlesave = async () => {
    const payload = {
      city: formData.city,
      home: formData.home,
      wall: formData.wall,
      feet: formData.feet,
      cabinet: formData.cabinet,
      finish: formData.finish,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      accessories: JSON.stringify(accessoriesQty)
    };
    await axios.post('https://squareandangle.pranatigroup.in/api/admin/elkitchen', payload);
     setaccessoriesQty({});
    setformData({
      city: '',
      home: '',
      wall: '',
      feet: '',
      cabinet: '',
      finish: '',
      name: '',
      email: '',
      phone: '',
      accessories: {}
    })
  };

  const increaseQty=(name)=>{
    setaccessoriesQty((prev)=>{
      const newState={};
      for(let key in prev){
        newState[key]=prev[key];
      }
      newState[name]=prev[name]?prev[name]+1:1;
     return newState;
    })
    }  

   const decreaseQty=(name)=>{
    setaccessoriesQty((prev)=>{
      const newState={};
      for(let key in prev){
        newState[key]=prev[key];
      }
      newState[name]=prev[name]?prev[name]-1:1;
      return newState;
    })
   }  

  const setkitchenshape = (e) => {
    const selectedKitchenShapeId = e.target.value;

    let wallarr = [];
    let feetarr = [];
  for (let i = 0; i < categorys.length; i++) {
     
      if (categorys[i].kichen_shape === selectedKitchenShapeId) {
        wallarr.push(categorys[i].Wall);
        feetarr.push(categorys[i].Feet);
      }
    }

    setwall(wallarr);
    setfeet(feetarr);
  };

  return (
    <>
      <div
        style={{
          background: '#f5f5f5',
          minHeight: '100vh',
          fontFamily: 'Arial'
        }}
      >
        <Header />
        <Marquee />

        <Helmet>
          <title>Pranati Interior - Kolkata best Interior</title>
          <meta name="description" content="Welcome to Kolkata best interior" />
          <link rel="canonical" href="https://squareandangle.pranatigroup.in/kitchen" />
          <meta property="og:title" content="Pranati interior" />
          <meta property="og:description" content="Kolkata best Interior" />
          <meta property="og:image" content="/images/preview.png" />
          <meta property="og:url" content="https://squareandangle.pranatigroup.in/kitchen" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Pranati interior" />
          <meta name="twitter:description" content="Kolkata best Interior" />
          <meta name="twitter:image" content="/images/preview.png" />
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'LocalBusiness',
              name: 'Pranati Interior',
              url: 'https://squareandangle.pranatigroup.in/kitchen',
              description: 'Kolkata best Interior',
              image: 'https://squareandangle.pranatigroup.in/images/preview.png',
              areaServed: 'Kolkata',
              address: {
                '@type': 'PostalAddress',
                addressLocality: 'Kolkata',
                addressRegion: 'West Bengal',
                addressCountry: 'IN'
              }
            })}
          </script>
        </Helmet>

        <div
          style={{
            background: 'linear-gradient(135deg,#ffffff,#f7f1eb)',
            padding: '60px 20px',
            textAlign: 'center'
          }}
        >
          <h1
            style={{
              fontSize: '42px',
              fontWeight: '700',
              color: '#222',
              marginBottom: '10px'
            }}
          >
            Kitchen Cost Calculator
          </h1>
          <p
            style={{
              color: '#666',
              fontSize: '18px',
              maxWidth: '700px',
              margin: 'auto'
            }}
          >
            Get an instant estimate for your dream kitchen with premium interior solutions.
          </p>
        </div>

        <div
          style={{
            maxWidth: '1100px',
            margin: '40px auto',
            background: '#fff',
            borderRadius: '20px',
            padding: '40px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.08)'
          }}
        >
          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '15px', color: '#222' }}>
              Step 1 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Select Your City</span>
            </h3>

            <select
              value={formData.city}
              onChange={(e) => setformData({ ...formData, city: e.target.value })}
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #ddd',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa'
              }}
            >
              {category.map((item, index) => (
                <option key={index} value={item.select_city}>
                  {item.select_city}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '15px', color: '#222' }}>
              Step 2 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Home Configuration</span>
            </h3>

            <select
             value={formData.home}
              onChange={(e) => setformData({ ...formData, home: e.target.value })}
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #ddd',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa'
              }}
            >
              {category.map((item, index) => (
                <option key={index} value={item.home_configuration}>
                  {item.home_configuration}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '15px', color: '#222' }}>
              Step 3 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Kitchen Shape</span>
            </h3>

            <select
              value={formData.kichen_shape}
              onChange={setkitchenshape}
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #ddd',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa'
              }}
            >
              {category.map((item, index) => (
                <option key={index} value={item.kichen_shape}>
                  {item.kichen_shape}
                </option>
              ))}
            </select>

            <div style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
              <div
                style={{
                  flex: 1,
                  background: '#fafafa',
                  borderRadius: '15px',
                  padding: '20px',
                  border: '1px solid #eee'
                }}
              >
                <h4 style={{ marginBottom: '15px', color: '#333' }}>Wall</h4>

                {wall.map((item, index) => (
                  <p
                    key={index}
                    style={{
                      background: '#fff',
                      padding: '10px',
                      borderRadius: '8px',
                      marginBottom: '10px'
                    }}
                  >
                    <input
                      type="radio"
                      name="wall"
                      onChange={(e) => setformData({ ...formData, wall: e.target.value })}
                      value={item} checked={formData.wall==item}
                    />
                    {item}
                  </p>
                ))}
              </div>

              

              <div
                style={{
                  flex: 1,
                  background: '#fafafa',
                  borderRadius: '15px',
                  padding: '20px',
                  border: '1px solid #eee'
                }}
              >
                <h4 style={{ marginBottom: '15px', color: '#333' }}>Feet</h4>

                {feet.map((item, index) => (
                  <p
                    key={index}
                    style={{
                      background: '#fff',
                      padding: '10px',
                      borderRadius: '8px',
                      marginBottom: '10px'
                    }}
                  >
                    <input
                      type="radio"
                      name="feet"
                      onChange={(e) => setformData({ ...formData, feet: e.target.value })}
                      value={item} checked={formData.feet==item}
                    />
                    {item}
                  </p>
                ))}
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '15px', color: '#222' }}>
              Step 4 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Cabinet Material</span>
            </h3>

            <select
              value={formData.cabinet}
              onChange={(e) => setformData({ ...formData, cabinet: e.target.value })}
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #ddd',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa'
              }}
            >
              {category.map((item, index) => (
                <option key={index} value={item.Cabinet_Material}>
                  {item.Cabinet_Material}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '15px', color: '#222' }}>
              Step 5 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Shutter Material & Finish</span>
            </h3>

            <select
             value={formData.finish}
              onChange={(e) => setformData({ ...formData, finish: e.target.value })}
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #ddd',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa'
              }}
            >
              {category.map((item, index) => (
                <option key={index} value={item.Shutter_Material_Finish}>
                  {item.Shutter_Material_Finish}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h3 style={{ fontSize: '22px', marginBottom: '20px', color: '#222' }}>
              Step 7 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Accessories</span>
            </h3>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
                gap: '20px'
              }}
            >
              {category.map((item, index) => (
                <div
                  key={index}
                  style={{
                    background: '#fafafa',
                    borderRadius: '12px',
                    border: '1px solid #eee',
                    padding: '15px',
                    textAlign: 'center'
                  }}
                >
                  <img
                    src={`http://api.squareandangle.pranatigroup.in/uploads/${item.photo}`}
                    alt={item.Accessories}
                    style={{
                      width: '100%',
                      height: '180px',
                      objectFit: 'cover',
                      borderRadius: '10px',
                      marginBottom: '10px'
                    }}
                  />

                  <p style={{ fontSize: '15px', color: '#333', minHeight: '45px' }}>{item.Accessories}</p>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginTop: '10px'
                    }}
                  >
                    <button
                      type="button"
                      onClick={() => decreaseQty(item.Accessories)}
                      style={{
                        width: '35px',
                        height: '35px',
                        border: '1px solid red',
                        background: '#fff',
                        color: '#000',
                        fontSize: '20px',
                        cursor: 'pointer'
                      }}
                    >
                      -
                    </button>

                    <div
                      style={{
                        width: '40px',
                        height: '35px',
                        background: 'red',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 'bold'
                      }}
                    >
                      {accessoriesQty[item.Accessories] || 0}
                    </div>

                    <button
                      type="button"
                      onClick={() => increaseQty(item.Accessories)}
                      style={{
                        width: '35px',
                        height: '35px',
                        border: '1px solid red',
                        background: '#fff',
                        color: '#000',
                        fontSize: '20px',
                        cursor: 'pointer'
                      }}
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 style={{ fontSize: '22px', marginBottom: '20px', color: '#222' }}>
              Step 8 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Name</span>
            </h3>
            <input
              type="text"
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #eee',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa',
                outline: 'none',
                marginBottom: '20px'
              }}
              onChange={(e) => setformData({ ...formData, name: e.target.value })}
              value={formData.name}
            />

            <h3 style={{ fontSize: '22px', marginBottom: '20px', color: '#222' }}>
              Step 9 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Phone</span>
            </h3>
            <input
              type="text"
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #eee',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa',
                outline: 'none',
                marginBottom: '20px'
              }}
              onChange={(e) => setformData({ ...formData, phone: e.target.value })}
              value={formData.phone}
            />

            <h3 style={{ fontSize: '22px', marginBottom: '20px', color: '#222' }}>
              Step 6 :
              <span style={{ color: '#d2691e', marginLeft: '8px' }}>Email</span>
            </h3>
            <input
              type="text"
              style={{
                width: '100%',
                height: '55px',
                borderRadius: '12px',
                border: '1px solid #eee',
                padding: '0 15px',
                fontSize: '16px',
                background: '#fafafa',
                outline: 'none',
                marginBottom: '20px'
              }}
              onChange={(e) => setformData({ ...formData, email: e.target.value })}
              value={formData.email}
            />
          </div>

          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <button
              type="button"
              onClick={handlesave}
              style={{
                background: '#d2691e',
                color: '#fff',
                border: 'none',
                padding: '16px 60px',
                borderRadius: '50px',
                fontSize: '18px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(210,105,30,0.3)'
              }}
            >
              Submit
            </button>
          </div>
        </div>

        <Footer />
        <WhatsAppButton />
        <Chat />
        <Call />
      </div>
    </>
  );
};

export default Kitchen;

